module.exports = __webpack_public_path__ + "static/bondetous-pres2-9e2ccfb8ebda1513fb39452635830e0c.png";